import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { buildUrl, getAuthToken } from "../../lib/request"

export const downloadMediaAsset = createAsyncThunk(
  "mediaDownload/downloadMediaAsset",
  async ({ assetId, filename }, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken()

      const url = buildUrl(`/media/asset/${assetId}/download`)

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          accept: "*/*",
        },
      })

      if (!response.ok) {
        throw new Error(`Download failed: ${response.status}`)
      }

      // Get blob from response
      const blob = await response.blob()

      // Create a blob URL and trigger download
      const blobUrl = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = blobUrl
      link.setAttribute("download", filename || `asset-${assetId}`)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(blobUrl)

      return { assetId, filename }
    } catch (error) {
      console.error("Error downloading media asset:", error)
      return rejectWithValue(error?.message || "Failed to download media asset")
    }
  },
)

const mediaDownloadSlice = createSlice({
  name: "mediaDownload",
  initialState: {
    status: "idle",
    error: null,
    downloadingAssetId: null,
  },
  reducers: {
    resetDownloadState: (state) => {
      state.status = "idle"
      state.error = null
      state.downloadingAssetId = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(downloadMediaAsset.pending, (state, action) => {
        state.status = "loading"
        state.downloadingAssetId = action.meta.arg.assetId
        state.error = null
      })
      .addCase(downloadMediaAsset.fulfilled, (state) => {
        state.status = "succeeded"
        state.downloadingAssetId = null
      })
      .addCase(downloadMediaAsset.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
        state.downloadingAssetId = null
      })
  },
})

export const { resetDownloadState } = mediaDownloadSlice.actions
export default mediaDownloadSlice.reducer
